import ef from 'ef/ef';
import SharedInitializationService from 'services/course-handler-services/initialization-service';

export default class InitializationService {
  static preload() {
    return Promise.resolve();
  }

  static load() {
    return [ef.enrollment.loadData(), ef.program.fetch()];
  }

  static applyTransformations(modulesJSON, modulesContentJson, groupsJSON) {
    return SharedInitializationService.applyTransformations(modulesJSON, modulesContentJson, groupsJSON);
  }
}
